<div class="d-flex justify-content-end mt-4">
  <app-cancel-button
    class="me-2"
    (cancelClick)="onCancelClick()"></app-cancel-button>
  <app-submit-button
    [isDisabled]="isSubmitDisabled"
    [submitBtnTranslationKey]="submitBtnTranslationKey"></app-submit-button>
</div>
